import "core-js/modules/es.array.find-index.js";
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    locked: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      required: true
    }
  },
  computed: {
    targetCollapsed: function targetCollapsed() {
      var _this = this;
      if (this.locked) return true;
      return this.collapseStore.collapsed.findIndex(function (o) {
        return o.id == _this.target;
      }) < 0;
    },
    collapseStore: function collapseStore() {
      return useCollapseStore();
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.locked) return;
      this.collapseStore.toggle(this.target);
    }
  }
};